<template>
    <div class="other-informations">
        <h2>{{translate('other_informations')}}</h2>
        <form>
            <input-custom :placeholder="translate('ral_colour_cover')" data-type="text" :require=true :regex="/[A-Za-z0-9]/"
                          name="fan_cover_color" :startValue="ral.cover" :isDisabled="isExActive && !isAdmin" :forceStartValue="true"/>
            <input-custom :placeholder="translate('ral_colour_engine')" data-type="text" :require=true :regex="/[A-Za-z0-9]/"
                          name="fan_engine_color" :startValue="ral.engine" :isDisabled="isExActive && !isAdmin" :forceStartValue="true"/>
            <input-custom :placeholder="translate('ral_colour_rest_of_fan')" data-type="text" :require=true
                          :regex="/[A-Za-z0-9]/" name="fan_color_rest" :startValue="ral.rest" :isDisabled="isExActive && !isAdmin" :forceStartValue="true"/>

            <div class="question-row">
                <input-position-fan :initial-data="positionsList"
                                    :placeholder="translate('select_fan_position')"
                                    :require=true
                                    name="fan_position">
                </input-position-fan>
                <div class="question-mark" @click="openPositionsModal()">
                    ?
                </div>
                <transition name="fade" mode="out-in" appear>
                <div class="positions-modal" v-if="positionsModalVisible">
                    <div class="background" @click="closePositionsModal()"></div>
                    <div class="modal-content">
                        <img src="/gfx/svg/wentylatory.svg" alt="positions-image">
                    </div>
                </div>
                </transition>
            </div>

            <input-custom :placeholder="translate('project_number')" data-type="text" :require=false
                          name="project_number"/>
            <input-custom :placeholder="translate('commission')" data-type="text" :require=false name="commission"/>
            <input-client :placeholder="translate('require_client')" data-type="text" :require=true :regex="/[A-Za-z0-9]/"
                          name="client"/>
            <input-note name="comment"/>

            <div class="navi-btns">
                <router-link to="/" class="back-btn">
                    <button class="circle-btn"/>
                </router-link>
                <button @click.prevent="trySend" class="summary-btn">{{translate('summary')}}</button>
            </div>
        </form>
    </div>
</template>

<script>
    import InputClient from "./information_inputs/inputClient";
    import InputNote from "./information_inputs/inputNote";
    import InputPositionFan from "./information_inputs/inputPositionFan";
    import InputCustom from "./information_inputs/inputCustom";

    export default {
        name: "other_information",
        components: {
            InputCustom,
            InputPositionFan,
            InputNote,
            InputClient,
        },

        data() {
            return {
                value: '',
                isIncorect: false,
                validationData: [],
                positionsList: [],
                positionsModalVisible: false
            }
        },

        methods: {

            translate(code) {
                let arg = {
                    type: 'translate',
                    code: code,
                    out: ""
                }

                this.$store.commit(arg);

                return arg.out;

            },

            openPositionsModal() {
                this.positionsModalVisible = true;
            },

            closePositionsModal() {
                this.positionsModalVisible = false;
            },

            trySend(e) {
                this.$emit('getValidateData');

                if (this.isSendingDisabled) {

                    console.error('Uzupełnij wszystkie pola');

                    e.preventDefault();

                    return;

                } else {
                    this.send(e);
                }

            },

            send(e) {
                let summaryData = {};
                for(let inputData of this.validationData){
                    summaryData[inputData.title] = inputData;
                }
                this.$store.state.productCard.custom.summary_form = summaryData;
                this.$router.push({path: 'result_form'})
            },

            isValidationDataValid() {

                if (this.validationData.length > 0) {

                    return !this.validationData.some(item => item.isIncorect === true)

                } else {
                    return false;
                }
            },

            getPositionsList() {
                let currentFanTypeId = this.$store.state.activeFun.selectedFanData.id_type;
                this.positionsList = [];

                if (currentFanTypeId == '' || null) {
                    throw new Error('No currentFanTypeId specified in activeFun');
                    return false;
                }

                for (let relations of this.$store.state.relationsFanTypesPositionsList) {
                    if (relations.id_fan_type === currentFanTypeId) {
                        let positionObject = this.$store.state.fansPositionsList.find(e => e.id === relations.id_fan_position);
                        positionObject['active'] = false;
                        this.positionsList.push(positionObject);
                    }
                }

                this.$store.state.accessories.fan_positions = this.positionsList;
            }
        },

        computed: {
            isSendingDisabled() {

                return (
                    !this.isValidationDataValid()
                );
            },
            ral() {
                // NVS-187
                if (this.$store.state.productCard.loaded) {
                    const cp = this.$store.state.productCard.custom.corrosion_protection.values;
                    return {
                        cover: cp.fan_cover_color.value,
                        engine: cp.fan_engine_color.value,
                        rest: cp.fan_color_rest.value,
                    };
                };
                // NVS-151
                if (this.isExActive) {
                    return {
                        cover: this.translate('antistatic_paint'),
                        engine: this.translate('antistatic_paint'),
                        rest: this.translate('antistatic_paint'),
                    };
                };
                return {
                    cover: '5015',
                    engine: '5015',
                    rest: '5015',
                };
            },
            isExActive() {
                return this.$store.state.fourthStepParametersSelected.ex.options[0].elements[1].active;
            },
            isAdmin() {
                return this.$store.getters.getUserRole == 'admin'
            },
        },

        mounted() {

            this.$on('validateData', (d) => {

                if (!this.validationData.some(item => item.title === d.title)) {

                    this.validationData.push(d);

                } else if (this.validationData.some(item => item.title === d.title)) {

                    this.validationData.forEach((element) => {

                        if (element.title === d.title) {

                            element.title = d.title;
                            element.isIncorect = d.isIncorect;
                            element.value = d.value ? d.value : '';
                        }
                    })
                }
            });

            this.getPositionsList();
        },

        beforeDestroy() {
            this.$off('validateData');
        }


    }
</script>